module.exports = __webpack_public_path__ + "img/group2.5ced9fb8.png";